module.exports = {
    list: ["SITE_HOSPITAL", "SITE_CLINIC", "SITE_RETIREMENT_HOME", "SITE_REHABILITATION_CENTER", "SITE_OTHER", "SITE_UNIVERSITY", "SITE_STORE", "SITE_TRAIN", "SITE_AIRPORT"]
};
